// extracted by mini-css-extract-plugin
export default {"container":"DD-z","dimension":"ED-z","dimensionLabels":"FD-z"};